function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".settings_svg__st0{fill:#1d1d1b}");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "settings_svg__Symbols"
}, /*#__PURE__*/React.createElement("g", {
  id: "settings_svg__menu_x2F_settings"
}, /*#__PURE__*/React.createElement("path", {
  id: "settings_svg__Oval",
  d: "M12.5 15.8c-1.8 0-3.2-1.5-3.2-3.2s1.5-3.2 3.2-3.2 3.2 1.5 3.2 3.2-1.4 3.2-3.2 3.2zm0-5c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8-.8-1.8-1.8-1.8z",
  className: "settings_svg__st0"
}), /*#__PURE__*/React.createElement("path", {
  id: "settings_svg__Combined-Shape",
  d: "M13.1 22h-1c-1.1 0-2-.9-2-2v-.5c-.3-.1-.5-.2-.7-.3l-.4.3c-.8.8-2.1.8-2.9 0l-.6-.5c-.8-.8-.8-2.1 0-2.9l.4-.4c-.1-.3-.2-.5-.3-.6V15H5c-1.1 0-2-.9-2-2v-1c0-1.1.9-2 2-2h.4l.1-.2.3-.6-.3-.3c-.8-.8-.8-2 0-2.8l.7-.7c.8-.8 2-.8 2.8 0l.3.3h.1c.1-.1.3-.2.6-.2V5c0-1.1.9-2.1 2-2.1h1c1 0 2 1 2 2.1v.5c.3.1.5.2.7.3l.3-.3c.8-.8 2.1-.8 2.9 0l.6.5c.8.8.8 2.1 0 2.9l-.2.2v.1c.1.3.2.5.3.6v.1h.5c1.1 0 2 .9 2 2v1c0 1.1-.9 2-2 2h-.5c-.1.3-.2.5-.3.7l.4.4c.8.8.8 2.1 0 2.9l-.7.6c-.8.8-2.1.8-2.9 0l-.4-.4c-.3.1-.5.2-.6.3H15v.6c0 1.1-.8 2-1.9 2zM9 17.4l1 .4c.2.1.4.2.7.3l1 .4V20c0 .3.3.5.5.5h1c.3 0 .5-.3.5-.5v-1.5l1-.4c.2-.1.4-.2.7-.3l.9-.4 1 1c.2.2.5.2.7 0l.7-.7c.2-.2.2-.5 0-.7l-1-1 .4-1c.1-.2.2-.4.3-.7l.4-1h1.5c.3 0 .5-.3.5-.5v-1c0-.3-.3-.5-.5-.5h-1.5l-.4-1c-.1-.2-.2-.4-.3-.7l-.4-.9.8-.9c.3-.3.3-.6 0-.8l-.7-.6c-.2-.2-.6-.2-.8 0l-1 1-1-.4c-.2-.1-.4-.2-.7-.3h-.1l-.8-.4V5c0-.3-.3-.6-.5-.6h-1c-.3 0-.5.3-.5.6v1.5l-1.1.4h-.1c-.1 0-.2 0-.4.1l-.8.5-1-.9c-.2-.2-.5-.2-.7 0l-.8.6c-.2.2-.2.4 0 .6L7.6 9l-.8 1.4-.2 1.1H5c-.3 0-.5.3-.5.5v1c0 .3.3.5.5.5h1.5l.4 1c.1.2.2.4.3.7l.4.9-1.1 1c-.2.2-.2.5 0 .7l.7.6c.2.2.6.2.8 0l1-1z",
  className: "settings_svg__st0"
})));

function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "settings_svg__Layer_1",
    width: 24,
    height: 24
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "da2a24897e5a36901744ba8a9662f663.svg";
export { SvgSettings as ReactComponent };